import { IPaymentDictionaryStore } from './index'

export default {
  dictionaries: [],
  services: [],
  error: false,
  invoiceSettings: {
    activeSecondTax: false,
    activeTax: false,
    createdAt: '',
    id: 0,
    idObject: 0,
    secondTaxName: '',
    secondTaxRate: '',
    taxName: '',
    taxRate: '',
    updatedAt: '',
  },
  request: {
    errMessage: '',
    isLoading: false,
  },
  taxDictionaries: [],
} as IPaymentDictionaryStore
